import * as GridSize from '../constants/GridSize'
import * as CommonConstants from '../constants/CommonConstants'
import {toCSVLineWithSep} from './StringUtils'
import {printNext} from '../common/NaMaPrinting'
import {showTextToCopyDialog} from '../views/ShowTextToCopyDialog'
import {getEntityImageInfo, isMasterFile, showFieldInfo, showIds} from '../login/ClientCache'
import {PopupQuickCreator} from "../views/edit/PopupQuickCreator";
import {currentTheme} from "../views/KednoThemeChooser";
import {user} from "../login/Security";
import {NamaKendoWindow, NamaWindowBtnData} from "../views/NamaKendoWindow";
import {ajaxJSON, fetchURL, isAnyTrue} from "./NamaCommon";
import {EditPresenter} from "../routing/EditPresenter";
import * as urls from "../constants/NamaURLS";

export function gridSizeToPixels(size) {
    return internalGridSizeToPixels(size) + 250;
}

export function genQRCodeForUserInfo() {
    let serverUrl;
    let defaultAdminPin;
    let defaultEmail;
    let defaultPrintingSdkVersion;
    ajaxJSON(urls.APPS_CONFIG, {}, (result) => {
            serverUrl = result.data.serverUrl;
            defaultAdminPin = result.data.defaultAdminPin;
            defaultEmail = result.data.defaultEmail;
            defaultPrintingSdkVersion = result.data.defaultPrintingSdkVersion;
            let container = $(`<div><span>
    Scan this QR Code from any of our apps login or settings screen to easily login.
    </span>
    <center><b>Scan me</b></br>
    <div id = "qrCode"></div>
    <div><br/>Employee Self Service App: <br/><a href='https://play.google.com/store/apps/details?id=com.namasoft.namaess' target="_blank">
    <img src='images/google-play-badge-en.png' width='120px' height='41px'/></a>
    <a href='https://apps.apple.com/eg/app/nama-ess/id1472348684' target="_blank">
    <img src='images/app_store_badge_en.png' width='120px' height='41px'/></a>
    </div>
     <div><br/>Receipts Vouchers App: <br/>
    <a href='https://play.google.com/store/apps/details?id=com.namasoft.android.receiptvouchers.exceed' target="_blank">
    <img src='images/google-play-badge-en.png' width='120px' height='41px'/>
    </a>
    </div>
    <div><br/>Nama Orders: <br/>
    <a href='https://play.google.com/store/apps/details?id=com.namasoft.android.namaOrders' target="_blank">
    <img src='images/google-play-badge-en.png' width='120px' height='41px'/>
    </a>
    </div>
    </div>`);
            let dialog = new NamaKendoWindow("genQrCode", new NamaWindowBtnData("ok", () => dialog.closeWindow()), new NamaWindowBtnData("cancel"), "40%");
            dialog.doCallBackFirstly = true;
            dialog.addDataWidget(container);
            let pathName = window.location.href.replace(window.location.hash, "").replace(window.location.search, "")
                .replace("#", "").replace("erp.html", "").replace("erp5.html", "").replace("erp1.html", "");
            let userName = user().loginId;
        let qr = "{\"user\":\"" + (userName || "") + "\"," +
            "\"deviceCode\":\"" + (userName || "") + "\"," +
            "\"adminPin\":\"" + (defaultAdminPin || "") + "\"," +
            "\"email\":\"" + (defaultEmail || "") + "\"," +
            "\"printingSdkVersion\":\"" + (defaultPrintingSdkVersion || "") + "\"," +
            "\"url\":\"" + (serverUrl || pathName || "") + "\"}";
            dialog.showWindow(() => genQRCode(dialog.content.find("#qrCode")[0], qr));
        }
    );
}

export function genQRCodeForMPSLogin(callback) {
    ajaxJSON(urls.NEW_UUID, {}, (result) => {
            let reqId = "mpsreq:" + result;
            let url = genMPSAuthURL(reqId);
            let container = $(`<div><span>
    Scan this QR Code Or Use The Link Below.
    </span>
    <center><b>Scan me</b></br>
    <div id = "qrCode"></div>
    <a href='${url}' target="_blank">Click Here (or Copy Link) If You do not have a phone</a>
    </div>
    </div>`);
            let dialog = new NamaKendoWindow("genQrCode", new NamaWindowBtnData("ok", () => dialog.closeWindow()), new NamaWindowBtnData("cancel"), "40%");
            dialog.doCallBackFirstly = true;
            dialog.addDataWidget(container);
            let qr = url;
            dialog.showWindow(() => genQRCode(dialog.content.find("#qrCode")[0], qr));
            scheduleNextMPSCheck(0, reqId, callback, dialog);
        }
    );
}

/**
 *
 * @param i : int
 * @param request : string
 * @param callback : Callback
 * @param dialogBox : NamaKendoWindow
 */
function scheduleNextMPSCheck(i, request, callback, dialogBox) {
    if (i >= 60) {
        dialogBox.closeWindow();
        window.alert("Could not authenticate - exiting now");
        return;
    }
    setTimeout(
        () => {
            let response = fetchURL(genMPSAuthCheckURL(request));
            if (!response) {
                scheduleNextMPSCheck(i + 1, request, callback, dialogBox);
            } else {
                dialogBox.closeWindow();
                callback(response);
            }
            return false;
        }, 1000);
}

function genMPSAuthCheckURL(request) {
    let crmURL = "https://crm.namasoft.com";
    let url = crmURL + "/erp/utils?" + CommonConstants.MPS_AUTH_RETRIEVE + "=" + request;
    return url;
}

function genMPSAuthURL(reqId) {
    let crmURL = "https://crm.namasoft.com";
    let url = crmURL + "/erp/utils?" + CommonConstants.MPS_AUTH + "=" + reqId;
    return url;
}

export function genQRCode(element, qr) {
    new QRCode(element, {
        text: qr,
        width: 300,
        height: 300,
        colorDark: "#000000",
        colorLight: "#ffffff",
    });

}

export function backToOldGui() {
    let location = window.location;
    let pathName = location.pathname;
    if (pathName.endsWith("/"))
        pathName = pathName + "erp1.html";
    else if (pathName.endsWith("erp5.html"))
        pathName = pathName.replace("erp5.html", "erp1.html");
    else if (pathName.endsWith("erp.html"))
        pathName = pathName.replace("erp.html", "erp1.html");
    let href = location.href.replace(location.pathname, pathName);
    window.open(href, "_blank");
}

export function internalGridSizeToPixels(size) {
    if (size === null)
        return 400;
    switch (size) {
        case GridSize.XXLarge:
            return 900;
        case GridSize.XLarge:
            return 700;
        case GridSize.Large:
            return 500;
        case GridSize.Medium:
            return 300;
        case GridSize.Small:
            return 200;
        case GridSize.VerySmall:
            return 150;
        case GridSize.Tiny:
            return 100;
        default:
            return 400;
    }
}

export function applyWidgetState(widget, state)
{
    let enable = true, show = true;
    if(state === "Enabled")
    {
        enable = true;
        show = true;
    }
    else if(state === "Disabled")
    {
        enable = false;
        show = true;
    }
    else if(state === "Invisible")
    {
        enable = true;
        show = false;
    }
    widget.setEnabled(enable);
    widget.setVisible(show);
    return (!enable || !show);
}

/**
 *
 * @param {PrintBarcodeData} printBarCode
 */
export function printBarcode(printBarCode)
{
    let barCodes = {};
    for (let print of printBarCode.barCodePrints)
    {
        getOrAddBarcodeList(print, barCodes).push(print.id);
    }
    let barcodeURLs = [];
    for (let entry of barCodes)
    {
        barcodeURLs.push(createBarcodeURL(entry.entityType, idsToBarcodeLine(entry.barCodesIds), entry.count));
    }
    printNext(barcodeURLs, 0);
}
/**
 *
 * @param {SingleBarCodePrint} print
 */
function getOrAddBarcodeList(print, barCodes)
{
    let key = print.entityType + print.count;
    let triple = barCodes[key];
    if (!triple)
    {
        /**
         * @type {namaTypes.MultiBarCodePrintData}
         */
        let multiBarCodePrintData = {};
        multiBarCodePrintData.entityType = print.entityType;
        multiBarCodePrintData.count = print.count;
        multiBarCodePrintData.barCodesIds = [];
        barCodes[key] = multiBarCodePrintData;
    }
    return triple.barCodesIds;
}

function createBarcodeURL(entityType, line, labelsCount)
{
    let url = CommonConstants.BARCODE_URL_PREFIX + entityType + CommonConstants.HOPEFULLY_UNIQUE_FIELD_SEP + labelsCount
        + CommonConstants.HOPEFULLY_UNIQUE_FIELD_SEP + line + CommonConstants.HOPEFULLY_UNIQUE_FIELD_SEP;
    return url;
}

function idsToBarcodeLine(ids)
{
    return toCSVLineWithSep(CommonConstants.HOPEFULLY_UNIQUE_FIELD_SEP, ids);
}

export function showTextToCopy(textToCopy)
{
    showTextToCopyDialog(textToCopy);
}
export function showQuickCreate(newObject, callBack, requesterType, tabId) {
    new PopupQuickCreator(newObject, null, callBack, requesterType, tabId).show();
}

/**
 *
 * @param {EditPresenter} presenter
 */
export function showIDs(presenter)
{
    showIds();
    presenter.start();
}/**
 *
 * @param {EditPresenter} presenter
 */
export function showHelpMSGs(presenter) {
    localStorage.setItem("showHelpsIsActive", "true");
    presenter.start();
}

export function showFieldInfo_()
{
    showFieldInfo();
}

export function isMobileDevice() {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
}

export function colorCode(object) {
    if (!object)
        return "";
    return object.colorCode ? object.colorCode : "";
}

export function calcForecolor(bgColor) {
    if (!bgColor)
        return "";
    let color = new tinycolor(bgColor);
    if (color.isDark())
        return "white";
    return "";
}

export function shouldAddMainFileWidget(entityType) {
    if (!entityType)
        return false;
    let entityImageInfo = getEntityImageInfo(entityType);
    return isMasterFile(entityType) && entityImageInfo && isAnyTrue(entityImageInfo.useInList, entityImageInfo.useInSuggestion, entityImageInfo.useInSearch,
        entityImageInfo.useInHeaderFields, entityImageInfo.showInSeparateColumn, entityImageInfo.useInGridColumns,
        entityImageInfo.showInPopupWithCode);
}

export function shouldShowImageOnHover(entityType) {
    if (!entityType)
        return false;
    let entityImageInfo = getEntityImageInfo(entityType);
    return entityImageInfo && entityImageInfo.showInPopupWithCode;
}

let themesWidgetBaseColors = new Map();
export function themesWidgetBaseColors_() {
    let theme = currentTheme();
    if (themesWidgetBaseColors.size)
        return themesWidgetBaseColors.get(theme);
    themesWidgetBaseColors.set("black", "#272727");
    themesWidgetBaseColors.set("blueopal", "#daecf4");
    themesWidgetBaseColors.set("bootstrap", "#ebebeb");
    themesWidgetBaseColors.set("default", "#e9e9e9");
    themesWidgetBaseColors.set("fiori", "#f2f2f2");
    themesWidgetBaseColors.set("flat", "#10c4b2");
    themesWidgetBaseColors.set("highcontrast", "#2c232b");
    themesWidgetBaseColors.set("material", "#ebebeb");
    themesWidgetBaseColors.set("metroblack", "#0e0e0e");
    themesWidgetBaseColors.set("moonlight", "#212a33");
    themesWidgetBaseColors.set("metro", "#dfdfdf");
    themesWidgetBaseColors.set("nova", "#dfdfdf");
    themesWidgetBaseColors.set("office365", "#ebebeb");
    themesWidgetBaseColors.set("silver", "#f3f3f4");
    themesWidgetBaseColors.set("uniform", "#ffffff");
    themesWidgetBaseColors.set("materialblack", "#ffffff");
    return themesWidgetBaseColors.get(theme);
}

export function isColor(strColor){
    let s = new Option().style;
    s.color = strColor;
    return s.color == strColor;
}

export function getServerAddressWithERP() {
    let path = location.pathname;
    if (path.endsWith(".html"))
        path = path.substring(0, path.lastIndexOf('/'));
    return location.origin + path;
}
